import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
import VeltCommentDialogStatusDropdownContentItemIconWireframe from './VeltCommentDialogStatusDropdownContentItemIconWireframe/VeltCommentDialogStatusDropdownContentItemIconWireframe';
import VeltCommentDialogStatusDropdownContentItemNameWireframe from './VeltCommentDialogStatusDropdownContentItemNameWireframe/VeltCommentDialogStatusDropdownContentItemNameWireframe';
;
var VeltCommentDialogStatusDropdownContentItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-dropdown-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogStatusDropdownContentItemWireframe.Icon = VeltCommentDialogStatusDropdownContentItemIconWireframe;
VeltCommentDialogStatusDropdownContentItemWireframe.Name = VeltCommentDialogStatusDropdownContentItemNameWireframe;
export default VeltCommentDialogStatusDropdownContentItemWireframe;
